import { UploadItem }    from 'angular2-http-file-upload';

export class uploadFile extends UploadItem {
    constructor(url, file, headers) {
        super();
        this.url = url;
        this.headers = headers;
        this.file = file;
    }
}



// WEBPACK FOOTER //
// ./src/app/routes/files/uploadFile.ts